import { TextField, Grid, MenuItem, Typography } from "@mui/material";
import { useFormContext, Controller } from "react-hook-form";

export default function VorbemerkungenForm() {
  const { control } = useFormContext();
  const managementOptions = ["Inhaber", "Geschäftsführer", "Vorstand"];

  const Beschriftung = ({ children }) => (
    <Typography variant="subtitle2" gutterBottom>{children}</Typography>
  );

  return (
    <Grid container spacing={3} direction="column">
      <>

      <Typography variant="h4" sx={{ fontWeight: 600, mb: 3 }}>
      Freigabe und Versionsverwaltung der Verfahrensdokumentation
      </Typography>

  <Typography paragraph>
    In diesem Formular werden grundlegende Angaben zu Genehmigung, Freigabe und Version der Verfahrensdokumentation erfasst. Bitte tragen Sie die folgenden Informationen ein:
  </Typography>
</>

      <Grid item xs={12}>
        <Beschriftung>  Wählen Sie aus, wer die Verfahrensdokumentation genehmigt hat. Ihnen stehen die Auswahlmöglichkeiten <strong>„Inhaber“</strong>, <strong>„Geschäftsführer“</strong> oder <strong>„Vorstand“</strong> zur Verfügung.</Beschriftung>
        <Controller
          name="management"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Genehmigung" select fullWidth>
              {managementOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          )}
        />
      </Grid>

      <Grid item xs={12}>
  <Beschriftung>
    Tragen Sie das Datum ein, an dem die Verfahrensdokumentation freigegeben wurde beziehungsweise wird.
  </Beschriftung>
  <Controller
    name="releaseDate"
    control={control}
    render={({ field }) => (
      <TextField
        {...field}
        label="Freigabedatum"
        type="date"
        InputLabelProps={{ shrink: true }}
        fullWidth
        value={field.value ?? new Date().toISOString().split("T")[0]} // 🆕 Default: heutiges Datum
      />
    )}
  />
</Grid>

      <Grid item xs={12}>
        <Beschriftung> Geben Sie den vollständigen Namen der Person an, die die Verfahrensdokumentation freigegeben hat.
        </Beschriftung>
        <Controller
          name="releasedBy"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Freigegeben von" fullWidth />
          )}
        />
      </Grid>

      <Grid item xs={12}>
        <Beschriftung> Tragen Sie die aktuelle Versionsbezeichnung der Verfahrensdokumentation ein (z. B. „Version 1.0“).
        </Beschriftung>
        <Controller
          name="version"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Version" fullWidth />
          )}
        />
      </Grid>


      <Grid item xs={12}>
        <Beschriftung>    Falls die aktuelle Version eine vorherige Version ersetzt, tragen Sie hier die Bezeichnung der ersetzten Version ein (z. B. „Version 0.9“). Andernfalls kann dieses Feld leer bleiben.
        </Beschriftung>
        <Controller
          name="previousVersion"
          control={control}
          render={({ field }) => (
            <TextField {...field} label="Ersetzte Version" fullWidth />
          )}
        />
      </Grid>
    </Grid>
  );
}
